//@utilities
const { PAGE_LOANS_MORTGAGES } = require("utilities/tagging");
export const analyticsId = {
    CLICK_BREADCRUMB_01: "CLICK_BREADCRUMB_01",
    CLICK_CHEVRON: "CLICK_CHEVRON",
    PAGE_VIEW_INFORMATION: "PAGE_VIEW_INFORMATION",
    PAGE_VIEW_MOVEMENTS: "PAGE_VIEW_MOVEMENTS",
    PAGE_VIEW_REPAYMENT_PLAN: "PAGE_VIEW_REPAYMENT_PLAN",
};

const commonFields = () => ({
    categoriaEvento: window.utag_last_name,
});

export const catalogue = {
    [analyticsId.CLICK_BREADCRUMB_01]: () => ({
        ...commonFields(),
        accionEvento: "préstamos e hipotecas",
        etiquetaEvento: "breadcrumb01",
    }),
    [analyticsId.CLICK_CHEVRON]: (isOpen) => ({
        ...commonFields(),
        accionEvento: "informacion detalle",
        etiquetaEvento: isOpen ? "abrir" : "cerrar",
    }),
    [analyticsId.PAGE_VIEW_MOVEMENTS]: (type, subType) => ({
        pathForTag: PAGE_LOANS_MORTGAGES + "/" + type + "/movimientos",
        procType: PAGE_LOANS_MORTGAGES,
        processDetails: type + "." + subType + "/movimientos",
    }),
    [analyticsId.PAGE_VIEW_REPAYMENT_PLAN]: (type, subType) => ({
        pathForTag: PAGE_LOANS_MORTGAGES + "/" + type + "/plan de amortizacion",
        procType: PAGE_LOANS_MORTGAGES,
        processDetails: type + "." + subType + "/plan de amortizacion",
    }),
    [analyticsId.PAGE_VIEW_INFORMATION]: (type, subType) => ({
        pathForTag: PAGE_LOANS_MORTGAGES + "/" + type,
        procType: PAGE_LOANS_MORTGAGES,
        processDetails: type + "." + subType,
    }),
};
